// Monitor de red: detecta si REALMENTE hay conexión con el servidor.
//
// No basta con navigator.onLine: en escritorio/Electron suele seguir en `true`
// aunque se desconecte el cable o caiga internet. Por eso hacemos un sondeo
// activo (ping ligero) al servidor y combinamos con los eventos del navegador.

const PROBE_URL = 'https://erp.ai-bos.co/api/';
const POLL_INTERVAL = 12000; // cada 12s
const PROBE_TIMEOUT = 8000;  // 8s máximo por sondeo

let online = typeof navigator !== 'undefined' ? navigator.onLine : true;
let storeRef = null;
let probing = false;

function setOnline(value) {
    if (value === online) return;
    online = value;
    console.log('📡 networkMonitor - estado de red:', value ? 'ONLINE' : 'OFFLINE');
    if (storeRef) storeRef.commit('setNetworkOnline', value);
}

// Sondea el servidor. Con mode:'no-cors' una respuesta (aunque sea 404) cuenta
// como "hay conexión"; solo un fallo de red real (DNS/offline) lanza excepción.
async function probe() {
    if (probing) return;
    probing = true;

    // Si el navegador ya sabe que no hay red, no gastamos un fetch
    if (typeof navigator !== 'undefined' && !navigator.onLine) {
        setOnline(false);
        probing = false;
        return;
    }

    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), PROBE_TIMEOUT);
    try {
        await fetch(PROBE_URL + '?_probe=' + Date.now(), {
            method: 'GET',
            mode: 'no-cors',
            cache: 'no-store',
            signal: controller.signal,
        });
        setOnline(true);
    } catch (e) {
        setOnline(false);
    } finally {
        clearTimeout(timer);
        probing = false;
    }
}

export function initNetworkMonitor(store) {
    if (typeof window === 'undefined') return;
    storeRef = store;

    // Estado inicial + primer sondeo
    store.commit('setNetworkOnline', online);
    probe();

    // Los eventos del navegador son una pista rápida; igual confirmamos con probe()
    window.addEventListener('online', probe);
    window.addEventListener('offline', () => setOnline(false));

    // Sondeo periódico
    setInterval(probe, POLL_INTERVAL);
}

// Estado actual (sincrónico) para la guarda de webserver()
export function isNetworkOnline() {
    return online;
}

// Fuerza un re-chequeo inmediato (p. ej. cuando una petición falla por red)
export function recheckNetwork() {
    probe();
}
